module.exports = __webpack_public_path__ + "static/4-37214a0ee8afd68fa5f28ffcce48fd68.jpg";